/* eslint-disable react/prop-types */
import React, {useState} from 'react'
import {
    makeStyles,
    Typography,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    FormHelperText,
    NativeSelect,
    Button,
} from '@material-ui/core/'
import { Alert } from '@material-ui/lab'
import { Formik } from 'formik';
import * as Yup from 'yup';
import {useHistory,useLocation} from 'react-router-dom';
import Professional from '../../services/Professional'

const useStyles = makeStyles({
    main_card: {
        width: '80%',
        display: 'flex',
        flexDirection: 'column',
        padding: '30px'
    },
    input: {
        marginTop: '15px'
    },
    btn: {
        marginTop: '10px'
    },
    alert: {
        marginBottom: '20px',
    }
})

const RegisterSchema = Yup.object().shape({
    name: Yup.string().required('Campo Obrigatório'),
    email: Yup.string().email('Email inválido').required('Campo obrigatório'),
    operation: Yup.string().required('Campo Obrigatório'),
});

export default function ProfessionalForm() {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()
    const [submit, setSubmit] = useState(false)
    const [submitError, setSubmitError] = useState(false)
    const professional = location.state.data

    const onSubmit = async (values) => {
        try {
            await Professional.edit(professional._id,values)
            setSubmitError(false)
            setSubmit(true)
            setTimeout(() => history.push("/professional"), 1000)
        }
        catch (err) {
            setSubmitError(true)
        }
    }
    return (
        <>
            <Paper elevation={3} className={classes.main_card}>
                {submit ? (
                    <Alert
                        severity="success"
                        className={classes.alert}>Cadastro editado com sucesso!
                    </Alert>)
                    : null}
                {submitError ? (
                    <Alert
                        severity="error"
                        className={classes.alert}>Ocorreu um problema ao tentar se comunicar com o servidor
                        , tente novamente!
                    </Alert>)
                    : null}
                <Typography variant='h6'>Editar cadastro</Typography>
                <Formik
                    initialValues={{
                        name: professional.name,
                        email: professional.email,
                        operation: professional.operation
                    }}
                    validationSchema={RegisterSchema}
                    onSubmit={onSubmit}
                >
                    {({ handleChange, handleBlur, handleSubmit, values, errors, touched }) => (
                        <>
                            <TextField
                                error={errors.name && touched.name ? true : false}
                                id="name"
                                label="Nome"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                helperText={
                                    errors.name && touched.name ? (
                                        errors.name
                                    ) : null
                                }
                            />
                            <TextField
                                error={errors.email && touched.email ? true : false}
                                id="email"
                                label="E-mail"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                helperText={
                                    errors.email && touched.email ? (
                                        errors.email
                                    ) : null
                                }
                            />
                            <FormControl className={classes.input}
                                error={errors.operation && touched.operation ? true : false}>
                                <InputLabel id="operation">Atuação</InputLabel>
                                <NativeSelect
                                    id="operation"
                                    value={values.operation}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    <option aria-label="None" value="" />
                                    <option value={'Enfermeiro(a)'}>Enfermeiro(a)</option>
                                    <option value={'Medico(a)'}>Médico(a)</option>
                                    <option value={'Administrativo'}>Administrativo</option>
                                </NativeSelect>
                                <FormHelperText>
                                    {
                                        errors.operation && touched.operation ? (
                                            errors.operation
                                        ) : null
                                    }
                                </FormHelperText>
                            </FormControl>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.btn}
                                onClick={handleSubmit}
                            >
                                Editar
                            </Button>
                        </>
                    )}
                </Formik>
            </Paper>
        </>
    )
}